/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AllegatoPayload } from './allegato-payload';
import { ComponenteAggiuntoPayload } from './componente-aggiunto-payload';
import { ComponenteRimossoPayload } from './componente-rimosso-payload';
import { EventoTipoPratica } from './evento-tipo-pratica';
import { OtpPayload } from './otp-payload';
import { TransizionePayload } from './transizione-payload';
import { NotaPayload } from './nota-payload';
import { AggiornamentoPayload } from './aggiornamento-payload';
import { TargetAllegato } from './target-allegato';
import { ComunicazionePayload } from './comunicazione-payload';
import { FieldChange } from './field-change';
import { ScoringPayload } from './scoring-payload';
import { ScoringManualOverridePayload } from './scoring-manual-override-payload';
import { OrigineAllegato } from './origine-allegato';


/**
 * @type PraticaEventoDTOPayload
 * @export
 */
export type PraticaEventoDTOPayload = AggiornamentoPayload | AllegatoPayload | ComponenteAggiuntoPayload | ComponenteRimossoPayload | ComunicazionePayload | NotaPayload | OtpPayload | ScoringManualOverridePayload | ScoringPayload | TransizionePayload;

